// import CustomFormBuilderSection from "../../components/FormBuilderComponent/CustomFormBuilderSection"
import FormBuilderSection from "../../components/FormBuilderComponent/FormBuilderSection"

const FormBuilderPage = () => {
    
    return (
        <FormBuilderSection />
        // <CustomFormBuilderSection />
    )
}

export default FormBuilderPage